// DATACENTRE REDUCER
const initialState = {
  fetched: false,
  selected: {},
  one: {},
  all: [],
  pagination: {}
};
export default function dataCentreReducer(state = initialState, action) {
  switch (action.type) {
    case 'DATACENTRE_GETALL_SUCCESS': {
      return {
        ...state,
        fetched: true,
        all: action.payload.content,
        pagination: {
          last: action.payload.isLast,
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          size: action.payload.size,
          number: action.payload.number,
          first: action.payload.isFirst,
          sort: action.payload.sort,
          numberOfElements: action.payload.numberOfElements
        }
      };
    }
    case 'DATACENTRE_GETONE_SUCCESS': {
      return {
        ...state,
        one: action.payload || initialState.one
      };
    }
    case 'DATACENTRE_CREATE_SUCCESS': {
      return {
        ...state,
        one: initialState.one
      };
    }
    case 'DATACENTRE_UPDATE_SUCCESS': {
      return {
        ...state,
        one: initialState.one
      };
    }
    case 'DATACENTRE_DELETE_SUCCESS': {
      return {
        ...state,
        one: initialState.one
      };
    }
    case 'DATACENTRE_SELECT': {
      return {
        ...state,
        selected: action.payload
      };
    }
    case 'DATACENTRE_CLEAR': {
      return {
        ...state,
        one: initialState.one
      };
    }
  }
  return state;
}
